import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Product from './pages/products/Product';
import QualityServices from './pages/QualityServices';
import Infrastructure from './pages/Infrastructure';
import Contact from './pages/Contact';
import ScrollToTop from "./components/ScrollToTop";
import Refractory_Bricks from './pages/products/refractory_bricks/Refractory_Bricks';
import Castable_Monolithics from './pages/products/castable_monolithics/Castable_Monolithics';
import Mortar from './pages/products/mortar/Mortar';
import Insulation_Fiber_Blanket from './pages/products/insulation_fiber_blanket/Insulation_Fiber_Blanket';
import Bauxite from './pages/products/Bauxite';
import Refractory_Cement from './pages/products/Refractory_Cement';
import Bed_Materials from './pages/products/Bed_Materials';
import Pre_Cast_Pre_Fire_Blocks from './pages/products/Pre_Cast_Pre_Fire_Blocks';
import FireClay_Bricks from './pages/products/refractory_bricks/FireClay_Bricks';
import High_Alumina_Bricks from './pages/products/refractory_bricks/High_Alumina_Bricks';
import Cupola_Bricks from './pages/products/refractory_bricks/Cupola_Bricks';
import ACID_Resistance_Bricks from './pages/products/refractory_bricks/ACID_Resistance_Bricks';
import Magnesia_Refractory_Bricks from './pages/products/refractory_bricks/Magnesia_Refractory_Bricks';
import Sillimanite_Refractory_Bricks from './pages/products/refractory_bricks/Sillimanite_Refractory_Bricks';
import Castable_Super from './pages/products/castable_monolithics/Castable_Super';
import White_Heat_A from './pages/products/castable_monolithics/White_Heat-A';
import White_Heat_C from './pages/products/castable_monolithics/White_Heat-C';
import White_Heat_K from './pages/products/castable_monolithics/White_Heat-K';
import LCC_60 from './pages/products/castable_monolithics/LCC-60';
import LCC_90 from './pages/products/castable_monolithics/LCC-90';
import Insulyte_7 from './pages/products/castable_monolithics/Insulyte-7';
import Insulyte_11 from './pages/products/castable_monolithics/Insulyte-11';
import Ramming_Mass from './pages/products/castable_monolithics/Ramming_Mass';
import Fireclay from './pages/products/mortar/Fireclay';
import IS_8_Morter from './pages/products/mortar/IS-8_Mortar';
import Acco_Set_50 from './pages/products/mortar/Acco_Set-50';
import Morter_70 from './pages/products/mortar/70%Mortar';
import ACID_Proof_Morter from './pages/products/mortar/ACID_Proof_Mortar';
import Thermotex from './pages/products/mortar/Thermotex';
import HFK_Insulation_Bricks from './pages/products/insulation_fiber_blanket/HFK_Insulation_Bricks';
import CFK_Insulation_Bricks from './pages/products/insulation_fiber_blanket/CFK_Insulation_Bricks';
import Ceramic_Fiber_Blankets from './pages/products/insulation_fiber_blanket/Ceramic_Fiber_Blankets';
import Ceramic_Fiber_Boards from './pages/products/insulation_fiber_blanket/Ceramic_Fiber_Boards';
import Ceramic_Fiber_Modules from './pages/products/insulation_fiber_blanket/Ceramic_Fiber_Modules';
import Hysil_Boards from './pages/products/insulation_fiber_blanket/Hysil_Boards';

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Routes>
                <Route path='/' element={<Home />} />
                <Route path='/about' element={<About />} />
                <Route path='/products' element={<Product />} />
                <Route path='/quality-services' element={<QualityServices />} />
                <Route path='/infrastructure' element={<Infrastructure />} />
                <Route path='/contact' element={<Contact />} />

                {/* product routes */}
                <Route path='/products/refractory_bricks' element={<Refractory_Bricks />} />
                <Route path='/products/castable-monolithics' element={<Castable_Monolithics />} />
                <Route path='/products/mortar' element={<Mortar />} />
                <Route path='/products/insulation-fiber-blanket' element={<Insulation_Fiber_Blanket />} />
                <Route path='/products/bauxite' element={<Bauxite />} />
                <Route path='/products/refractory-cement' element={<Refractory_Cement />} />
                <Route path='/products/bed-materials' element={<Bed_Materials />} />
                <Route path='/products/precast-prefire' element={<Pre_Cast_Pre_Fire_Blocks />} />

                {/* refractory_bricks routes */}
                <Route path='/products/fireclay_bricks' element={<FireClay_Bricks />} />
                <Route path='/products/high_alumina_bricks' element={<High_Alumina_Bricks />} />
                <Route path='/products/cupola_bricks' element={<Cupola_Bricks />} />
                <Route path='/products/acid_resistance_bricks' element={<ACID_Resistance_Bricks />} />
                <Route path='/products/magnesia_refractory_bricks' element={<Magnesia_Refractory_Bricks />} />
                <Route path='/products/sillimanite_refractory_bricks' element={<Sillimanite_Refractory_Bricks />} />

                {/* castable_monolithics routes */}
                <Route path='/products/castable_super' element={<Castable_Super />} />
                <Route path='/products/white_heat-a' element={<White_Heat_A />} />
                <Route path='/products/white_heat-c' element={<White_Heat_C />} />
                <Route path='/products/white_heat-k' element={<White_Heat_K />} />
                <Route path='/products/lcc-60' element={<LCC_60 />} />
                <Route path='/products/lcc-90' element={<LCC_90 />} />
                <Route path='/products/insulyte-7' element={<Insulyte_7 />} />
                <Route path='/products/insulyte-11' element={<Insulyte_11 />} />
                <Route path='/products/ramming_mass' element={<Ramming_Mass />} />

                {/* mortar routes */}
                <Route path='/products/fireclay' element={<Fireclay />} />
                <Route path='/products/is-8-morter' element={<IS_8_Morter />} />
                <Route path='/products/acco-set-50' element={<Acco_Set_50 />} />
                <Route path='/products/morter-70' element={<Morter_70 />} />
                <Route path='/products/acid-proof-morter' element={<ACID_Proof_Morter />} />
                <Route path='/products/thermotex' element={<Thermotex />} />

                {/* insulation fiber blanket routes */}
                <Route path='/products/hfk-insulation-bricks' element={<HFK_Insulation_Bricks />} />
                <Route path='/products/cfk-insulation-bricks' element={<CFK_Insulation_Bricks />} />
                <Route path='/products/ceramic-fiber-blankets' element={<Ceramic_Fiber_Blankets />} />
                <Route path='/products/hysil-boards' element={<Hysil_Boards />} />
                <Route path='/products/ceramic-fiber-boards' element={<Ceramic_Fiber_Boards />} />
                <Route path='/products/ceramic-fiber-modules' element={<Ceramic_Fiber_Modules />} />


            </Routes>
        </BrowserRouter>
    );
}

export default App;
